'use client';

import logger from 'logger';
import { useTranslation } from 'react-i18next';
import { DetailsPageTitle, PageSection, Stack, Typography } from 'ui';

import { useContract } from '~/contract/hooks';
import { GoBackButton } from '~/ui';

import { ContractDetailedData } from '../list';
import { ContractAnnexes } from '../list/ContractAnnexes';
import { ContractDownloadButton } from './ContractDownloadButton';

interface Props {
  contractNumber: string;
}
export const ContractDetails = ({ contractNumber }: Props) => {
  const { t } = useTranslation();

  const {
    data: { contract, annexes, contractFile },
  } = useContract({ contractNumber });

  if (!contract) {
    logger.debug('Contract not found');
    return null;
  }

  return (
    <>
      <DetailsPageTitle
        leftButtons={<GoBackButton />}
        subtitle={t('contracts:contractNumber', { contractNumber: contract.contractNumber })}
        title={contract.contractType}
        rightButtons={
          <ContractDownloadButton downloadUrl={contractFile.downloadUrl} loading={!contractFile.downloadUrl} />
        }
      />

      <Stack spacing={4} mt={4}>
        <ContractDetailedData contract={contract} />

        <PageSection
          data-testid="contract-annexes"
          title={t('contracts:annexes')}
          subtitle={
            <Stack direction="row" alignItems="end" gap={1}>
              <Typography variant="h6" color="primary.main" fontWeight="bold" lineHeight={1.4}>
                {annexes.total}
              </Typography>
            </Stack>
          }
        >
          <ContractAnnexes
            list={annexes.items}
            customerName={contract.customerName}
            contractNumber={contract.contractNumber}
          />
        </PageSection>
      </Stack>
    </>
  );
};
